import { render, staticRenderFns } from "./blocks.vue?vue&type=template&id=3361e83a"
import script from "./blocks.vue?vue&type=script&lang=js"
export * from "./blocks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports